/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Mute_MicInputs */

const th_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดไมโครโฟน`)
};

const en_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mute microphone`)
};

const ja_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイクをミュート`)
};

const zh_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`静音麦克风`)
};

const es_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silenciar el micrófono`)
};

const pt_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligar o microfone`)
};

const id_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisukan mikrofon`)
};

const fr_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper le micro`)
};

const tl_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-mute ang mikropono`)
};

const vi_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt micrô`)
};

const ko_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마이크 음소거`)
};

const de_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrofon stummschalten`)
};

const ru_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выключить микрофон`)
};

const tr_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrofonu kapat`)
};

const it_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattiva il microfono`)
};

const pl_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycisz mikrofon`)
};

const uk_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вимкнути мікрофон`)
};

const hi_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माइक बंद करें`)
};

const ar_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتم الميكروفون`)
};

const ms_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senyapkan mikrofon`)
};

const bn_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাইক বন্ধ করুন`)
};

const zh_tw2_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`將麥克風靜音`)
};

const zh_hk2_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`將麥克風靜音`)
};

const ur_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مائیک خاموش کریں`)
};

const fa_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بی‌صدا کردن میکروفون`)
};

const sw_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zima maikrofoni`)
};

const nl_meeting_mute_mic = /** @type {(inputs: Meeting_Mute_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microfoon uitzetten`)
};

/**
* | output |
* | --- |
* | "Mute microphone" |
*
* @param {Meeting_Mute_MicInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_mute_mic = /** @type {((inputs?: Meeting_Mute_MicInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Mute_MicInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_mute_mic(inputs)
	if (locale === "ja") return ja_meeting_mute_mic(inputs)
	if (locale === "zh") return zh_meeting_mute_mic(inputs)
	if (locale === "es") return es_meeting_mute_mic(inputs)
	if (locale === "pt") return pt_meeting_mute_mic(inputs)
	if (locale === "id") return id_meeting_mute_mic(inputs)
	if (locale === "fr") return fr_meeting_mute_mic(inputs)
	if (locale === "tl") return tl_meeting_mute_mic(inputs)
	if (locale === "vi") return vi_meeting_mute_mic(inputs)
	if (locale === "ko") return ko_meeting_mute_mic(inputs)
	if (locale === "de") return de_meeting_mute_mic(inputs)
	if (locale === "ru") return ru_meeting_mute_mic(inputs)
	if (locale === "tr") return tr_meeting_mute_mic(inputs)
	if (locale === "it") return it_meeting_mute_mic(inputs)
	if (locale === "pl") return pl_meeting_mute_mic(inputs)
	if (locale === "uk") return uk_meeting_mute_mic(inputs)
	if (locale === "hi") return hi_meeting_mute_mic(inputs)
	if (locale === "ar") return ar_meeting_mute_mic(inputs)
	if (locale === "ms") return ms_meeting_mute_mic(inputs)
	if (locale === "bn") return bn_meeting_mute_mic(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_mute_mic(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_mute_mic(inputs)
	if (locale === "ur") return ur_meeting_mute_mic(inputs)
	if (locale === "fa") return fa_meeting_mute_mic(inputs)
	if (locale === "sw") return sw_meeting_mute_mic(inputs)
	if (locale === "nl") return nl_meeting_mute_mic(inputs)
	return en_meeting_mute_mic(inputs)
});